/**
 * Returns true if the given meeting invite is sent by the given user ID.
 * @param {number} selfUserId - The user ID to check.
 * @param {object} meeting - The meeting object to check.
 * @return {boolean} Returns true if the meeting invite is sent by the given user ID, false otherwise.
 */
export function isMeetingCreatedByUser(selfUserId, meeting) {
    return meeting.initiator.id == selfUserId;
}
